import { pickAppCopy, type SupportedLocale } from "@patient-watch/i18n";
import { useAppLocale } from "./LocaleContext";
import { painSliderCopyEn } from "@patient-watch/i18n/webapp/en-GB/painSliderCopy";
import { painSliderCopyDe } from "@patient-watch/i18n/webapp/de-DE/painSliderCopy";
import { painSliderCopyDa } from "@patient-watch/i18n/webapp/da-DK/painSliderCopy";
import { painSliderCopyEnUs } from "@patient-watch/i18n/webapp/en-US/painSliderCopy";
import { painSliderCopyFr } from "@patient-watch/i18n/webapp/fr-FR/painSliderCopy";
import { painSliderCopyIt } from "@patient-watch/i18n/webapp/it-IT/painSliderCopy";
import { painSliderCopyEs } from "@patient-watch/i18n/webapp/es-ES/painSliderCopy";

interface PainSliderCopy {
    scoringHint: string;
}

const painSliderCopy: Record<SupportedLocale, PainSliderCopy> = {
    "en-GB": painSliderCopyEn,
    "en-US": painSliderCopyEnUs,
    "de-DE": painSliderCopyDe,
    "da-DK": painSliderCopyDa,
    "fr-FR": painSliderCopyFr,
    "it-IT": painSliderCopyIt,
    "es-ES": painSliderCopyEs,
};

export function usePainSliderCopy(): PainSliderCopy {
    const { locale } = useAppLocale();
    return pickAppCopy(painSliderCopy, locale);
}
